(function () {
	"use strict";

	/* Make anchor link go some pixels above where it's linked to
	   https://stackoverflow.com/a/17535094/5238306
	   This will capture hash changes while on the page */
	window.addEventListener("hashchange", offsetAnchor);

	// The function actually applying the offset
	function offsetAnchor() {

		var header_height = document.getElementById('masthead').offsetHeight;

		var adminbar = document.getElementById('wpadminbar');

		if (adminbar) {
			header_height += adminbar.offsetHeight;
		}

		if (location.hash.length !== 0) {
			window.scrollTo(window.scrollX, window.scrollY - header_height - 19);
		}
	}

	/* This is here so that when you enter the page with a hash,
	   it can provide the offset in that case too. Having a timeout
	   seems necessary to allow the browser to jump to the anchor first.
	   The delay of 1 is arbitrary and may not always work right (although it did in my testing). */
	window.setTimeout(offsetAnchor, 1);
})();
